export enum OPTIONS_CONTENT_TYPE {
  MUSIC = 'music',
  PODCAST = 'podcast',
  ARTWORK = 'artwork',
  USER_IMAGE = 'user_image',
  PLAYLIST_IMAGE = 'playlist_image',
  PLAYLIST_TITLE = 'playlist_title',
  PLAYLIST_DESCRIPTION = 'playlist_description',
  ARTIST_PROFILE_IMAGE = 'artist_profile_image',
  ARTIST_BANNER_IMAGE = 'artist_banner_image',
  ARTIST_GALLERY_IMAGE = 'artist_gallery_image',
  ARTIST_BIO_TEXT = 'artist_bio_text',
  ARTIST_PICK_TEXT = 'artist_pick_text',
  ARTIST_MERCHANDISE = 'artist_merchandise',
  NOW_PLAYING = 'now_playing',
  OTHER = 'other',
  AUDIOBOOK = 'audiobook',
  ARTIST_VIDEO_VIDEO = 'artist_video_video',
  ARTIST_VIDEO_TITLE = 'artist_video_title',
  ARTIST_VIDEO_AUDIO = 'artist_video_audio',
  QUESTION_TEXT = 'question_text',
  RESPONSE_TEXT = 'response_text',
  POLL_QUESTION_TEXT = 'poll_question_text',
  COMMENT_TEXT = 'comment_text',
  MERCH_TITLE = 'merch_title',
  POLL_OPTIONS_TEXT = 'poll_options_text',
  MERCH_DESCRIPTION = 'merch_description',
  MERCH_IMAGE_GALLERY = 'merch_image_gallery',
  MUSIC_VIDEO = 'music_video',
  EPISODE_VIDEO_PREVIEW_AUDIO = 'episode_video_preview_audio',
  SUPPLEMENTARY_PDF = 'supplementary_pdf',
}

export const USE_LABEL_FROM_TRANSLATION_PREFIX: string = '_label';

export enum Platform {
  IOS = 'ios',
  ANDROID = 'android',
  LIVE_APP_IOS = 'live-app-ios',
  LIVE_APP_ANDROID = 'live-app-android',
  DESKTOP = 'desktop',
  DESKTOP_WEB = 'desktop-web',
}
